const locale = {
	INITIALIZATION_TITLE: '初期化',
	enter_project_branch: '支店名',
	enter_project_type: '現場区分',
	enter_group_type:'所属',
	enter_user_position:'追加 役職',
	edit_details: '編集',
	active:'有効',
	inactive:'無効',
	unverified: '未確認',
	deleted: '削除',
	submit:'登録',
	export: 'ファイルに出力',
	cancel:'キャンセル',
	update:'更新',
	delete: '削除',
	recover:'復帰する',
	companies:'企業',
	search:'検索',
	filter:'絞り込み',
	filter_by:'絞り込み条件:',
	reset_filters:'絞り込みをリセット',
	status:'ステータス',
	actions:'オプション',
	initialization:'初期化',
	project_branch: '支店名',
	project_type: '現場区分',
	group_type: '所属',
	user_position: '役職',
	add_project_branch: '追加 支店名',
	add_project_type: '追加 現場区分',
	add_group_type: '追加 所属',
	add_user_position: '追加 役職',
	edit_project_branch: '編集 支店名',
	edit_project_type: '編集 現場区分',
	edit_group_type: '編集 所属',
	edit_user_position: '編集 役職',
	if_you_want_to_give_a_specific_name_for_this_position:'この役職に名前を付けますか？',
	do_you_want_to_remove_this_project_branch : '支店名 削除',
	do_you_want_to_remove_this_project_type : '現場区分 削除',
	do_you_want_to_remove_this_group_type : '編集 所属 削除',
	do_you_want_to_remove_this_user_position : '追加 役職 削除',
	do_you_want_to_recover_this_project_branch : '支店名 復帰する',
	do_you_want_to_recover_this_project_type : '現場区分 復帰する',
	do_you_want_to_recover_this_group_type : '編集 所属 復帰する',
	do_you_want_to_recover_this_user_position : '追加 役職 復帰する',
	no : 'No',
	enter_position_local_name:'日本語',
	this_name_already_exist:'この名前は既に存在します',

	project_branch_local_name: '日本語',
	project_type_local_name: '日本語',
	group_type_local_name: '日本語',
	user_position_local_name: '日本語',
	local_name: '日本語',
	created_succesfully:'作成完了',
	updated_succesfully: '更新完了',
	something_went_wrong: 'エラー!',
};

export default locale;